import { HttpBadStatusCodeError } from '@cian/peperrors/shared';

import { prepareOffers } from 'shared/mappers/prepareOffers';
import {
  TPublicDesktopV1OffersGetOffersRequest,
  TPublicDesktopV1OffersGetOffersResponse,
  fetchPublicDesktopV1OffersGetOffers,
} from 'shared/repositories/commercial-search-offers/desktop/v1/offers/get-offers';
import { IApplicationContext } from 'shared/types/applicationContext';
import { IOffersData } from 'shared/types/offersData';

export async function fetchOffers(
  { httpApi, logger }: Pick<IApplicationContext, 'httpApi' | 'logger'>,
  parameters: TPublicDesktopV1OffersGetOffersRequest,
): Promise<IOffersData> {
  const result = await fetchPublicDesktopV1OffersGetOffers<
    TPublicDesktopV1OffersGetOffersResponse,
    TPublicDesktopV1OffersGetOffersResponse
  >({
    httpApi,
    parameters,
  });

  switch (result.statusCode) {
    case 200:
      return prepareOffers(result.response);
    case 400:
    default: {
      const err = new HttpBadStatusCodeError({
        domain: 'src/shared/services/fetchOffers/fetchOffers.ts',
        message: result.response.message,
        details: {
          error: typeof result.response.errors === 'object' && JSON.stringify(result.response.errors),
        },
        statusCode: result.statusCode,
      });

      logger.error(err);

      throw err;
    }
  }
}
